import { useRef } from 'react';
import styled from '@emotion/styled';
import { useParticipantTracks, useAttachTrack } from '../helpers/video/useParticipantTracks';

const StyledVideo = styled.video`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

const MobileVideo = ({ participant }) => {
  const { videoTrack, audioTrack } = useParticipantTracks(participant);
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  useAttachTrack(videoTrack, videoRef);
  useAttachTrack(audioTrack, audioRef);

  return (
    <>
      <audio ref={audioRef} autoPlay />
      <StyledVideo ref={videoRef} autoPlay playsInline muted id={participant.sid} />
    </>
  );
};

export default MobileVideo;
